/**
 * Labstep
 *
 * @module constants/prosemirror
 * @desc ProseMirror-related constants
 */

export const REFERENCING_TRIGGER = '@';
export const SLASH_TRIGGER = '/';
